


















































import { Vue, Component, Prop } from "vue-property-decorator";
import { Education as IEducation } from "@/api-v2/student-document-info/models/education";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CField from "@/components/form/CField.vue";
@Component({
  components: { CField, CustomDatepicker }
})
export default class StudentDocInfoEducation extends Vue {
  @Prop() education?: IEducation;
  form: IEducation = {
    //@ts-ignore
    date: undefined,
    institution: "",
    education: "",
    number: "",
    registrationNumber: "",
    surname: "",
    series: ""
  };

  get docInfoEducation(): IEducation | undefined {
    const isHasValues = Object.values(this.form).some(item => item);
    return isHasValues ? this.form : undefined;
  }

  created() {
    this.form = this.education ?? this.form;
  }
}
